import React from 'react'
import BlogPost from './BlogPost'

export default function Choice() {
  return (
    <BlogPost
      translationKey="choice"
      seoTitle="선택 | Hyunjin Jae"
      seoDescription="사랑을 선택하는 일에 대한 짧은 생각입니다."
      seoKeywords="사랑, 선택, 관계, love, choice, relationship"
      seoTags={['love', 'choice', 'reflection']}
    />
  )
}
